// to be used client-side
const keys: Record<string, boolean> = {}
export default function (key: string, callback: Function) {
  if (keys[key] === true) return

  keys[key] = true
  callback()
}
